module.exports = __webpack_public_path__ + "img/recycle.e4ac6561.svg";